import { render, staticRenderFns } from "./Portal.vue?vue&type=template&id=47f5856c&"
import script from "./Portal.vue?vue&type=script&lang=js&"
export * from "./Portal.vue?vue&type=script&lang=js&"
import style0 from "./Portal.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/unitech/keymetrics/pm2-io/pm2-io-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47f5856c')) {
      api.createRecord('47f5856c', component.options)
    } else {
      api.reload('47f5856c', component.options)
    }
    module.hot.accept("./Portal.vue?vue&type=template&id=47f5856c&", function () {
      api.rerender('47f5856c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/KmTooltip/Portal.vue"
export default component.exports